import React from 'react';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import styled from 'styled-components';
import styledProps from 'styled-props';
import { colors } from '../../../tailwind';
import InputStyle from './InputStyle';
import { Text } from '../../../components_new/common';

export const FormGroupStyled = styled(FormGroup)`
  width: ${props => (props.width ? props.width : '100%')};
`;

export const ControlLabelStyled = styled(ControlLabel)`
  height: 19px;
  font-family: Helvetica;
  text-align: ${props => props.textAlign || 'left'}
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  display: block;
  margin-bottom: 8px;
  color: ${styledProps(colors)};
`;

class Input extends React.Component {
  render() {
    const { width, errors, name, noFilter, type } = this.props;
    const errs = noFilter
      ? errors
      : errors
      ? errors.filter(x => x.toLowerCase().indexOf(name.toLowerCase()) > -1)
      : [];
    const validationState = errs && errs.length > 0 ? 'error' : null;

    return (
      <FormGroupStyled
        controlId={this.props.id}
        validationState={validationState}
        width={width}
      >
        {this.props.label && (
          <ControlLabelStyled grayDarkMedium primary={this.props.primary}>
            {this.props.label}
          </ControlLabelStyled>
        )}
        <Field
          name={this.props.name}
          onBlur={e => e.preventDefault()}
          onFocus={e => e.preventDefault()}
          component={({ input }) =>
            (type === 'price' && (
              <InputStyle
                type="number"
                min="1"
                step="1"
                max={this.props.max || 10000}
                {...input}
                onKeyPress={event => {
                  if (
                    event.charCode == 8 ||
                    event.charCode == 0 ||
                    event.charCode == 13 ||
                    (event.charCode >= 48 && event.charCode <= 57)
                  ) {
                  } else {
                    event.preventDefault();
                  }
                }}
              />
            )) || (
              <InputStyle
                type={type}
                placeholder={this.props.placeholder}
                {...input}
              />
            )
          }
        />
        {errs && validationState === 'error' && (
          <HelpBlock>
            <Text secondary>{errors[0]}</Text>
          </HelpBlock>
        )}
        {this.props.helpText && <HelpBlock>{this.props.helpText}</HelpBlock>}
      </FormGroupStyled>
    );
  }
}

export default connect(
  null,
  {},
)(Input);



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/Input.js